import moment from 'moment';
import {setTimelineToNow} from '../actions';

const IDLE_TIMEOUT_MS = 10 * 60 * 1000;

let _lastActionTime;

const checkInactivity = (dispatch) => {
  if (new Date().getTime() - _lastActionTime >= IDLE_TIMEOUT_MS) {
    dispatch(setTimelineToNow());
  }
};

export const handleInactivity = store => next => action => {
  const dispatch = store.dispatch;
  const result = next(action);
  if (!_lastActionTime) {
    const timeout = moment().minutes(0).seconds(0).add(1, 'h').valueOf() - new Date().getTime();
    setTimeout(() => {
      checkInactivity(dispatch);
      setInterval(() => checkInactivity(dispatch), 60 * 60 * 1000);
    }, timeout);
  }
  _lastActionTime = new Date().getTime();
  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/inactivityMiddleware.js